import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'


export const _ListInfo = styled.ul`
  width: 100%;
  list-style: none;
  padding: 0 9px 0 0;
  margin: 0;
  display: flex;
  height: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  ${({ forMobile }) => (forMobile &&
    'position:relative;' +
    'right: 84px;' +
    'bottom: 0;' +
    'flex-wrap: nowrap;')}
  li {
    width: 50%;
    margin-top: 2px;
    line-height: 22px;
    font-size: 12px;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    svg{
      margin-right: 6px;
    }
    div {
      line-height: 22px;
      font-size: 12px;
    }

    ${({ forMobile }) => (forMobile ?
    'margin-right: 10px;' +
    'white-space: nowrap;' :
    'min-width: 50%;'
  )}
  }
  div {
   display: flex;
  }
  > li:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    //display: none;
    li {
      font-size: 10px !important;

    }
  }
  ${({ isHiddenOnPrint }) => (isHiddenOnPrint && 'opacity: 0.4;')};
  @media screen and (max-width: 350px) {
    right: 0;
  }
`

export const _SqftRange = styled.li`
  @media screen and (max-width: 350px) {
    white-space: normal !important;
  }
`
